import type { SVGProps } from 'react';

export function EthereumIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m5.551 11.321 5.6-8.963a1 1 0 0 1 1.696 0l5.598 8.963a1 1 0 0 1-.353 1.399l-5.598 3.193a1 1 0 0 1-.991 0L5.904 12.72a1 1 0 0 1-.353-1.399" />
      <path d="m11.193 21.905-4.798-6.523c-.32-.435.181-.998.65-.731l4.458 2.541a1 1 0 0 0 .99 0l4.461-2.541c.47-.268.97.295.65.73l-4.8 6.524a1 1 0 0 1-1.611 0" />
    </svg>
  );
}
